// Attention on a mention while the app is in the background (PARITY P337) — the web's version of the
// Windows taskbar flash (`FlashWindowEx`, DesktopIntegration.cs) and the Mac's Dock bounce: when the
// mention count RISES while the reader is not looking at the page, the tab title alternates with
// «(N) Te mencionaron» until the page is in front again. Only a rise starts it (a count read on
// another device falling is not news), and the page coming to the front always stops it.

export const attentionBlinkMillis = 1000;

/** Whether this change of the mention count should start the blink. */
function shouldStart(previousMentions: number, mentions: number, pageInFront: boolean): boolean {
  return !pageInFront && mentions > previousMentions && mentions > 0;
}

/** The title shown on the "on" beats. */
function alertTitle(mentions: number, label: string): string {
  return `(${mentions > 99 ? '99+' : mentions}) ${label}`;
}

export const AttentionBlink = { shouldStart, alertTitle } as const;
